import React from "react"

const ListItem = ({ attributes, children, data }) => {
  const { alignment } = data

  const style = {}

  if (alignment) style.textAlign = alignment

  return (
    <li className={"list_item"} {...attributes}>
      {children}
    </li>
  )
}

export default {
  component: ListItem
}
